import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormBuilder, Validators } from "@angular/forms";
import { DialogConfig } from "src/app/core/components/dialog/dialog-config";
import { DialogRef } from "src/app/core/components/dialog/dialog-ref";

import { PersonType } from "src/app/lem/models/person/person-type";

@Component({
  selector: "app-newperson-form",
  templateUrl: "./newperson-form.component.html",
  styleUrls: ["./newperson-form.component.css"],
})
export class NewpersonFormComponent implements OnInit {
  formData;
  formEdit;

  personType: PersonType;
  newPersonForm: FormGroup;
  // TODO TSR-197 FORM SWITCH INPUT - VALIDATORS -> LEGAL - PHYSICAL

  constructor(
    private formBuilder: FormBuilder,
    private modalRef: DialogRef,
    private dialogConfig: DialogConfig
  ) {
    this.newPersonForm = formBuilder.group({
      type: [null, Validators.required],
      taxNumber: [
        "",
        Validators.required,
        ,
        Validators.minLength(16),
        Validators.maxLength(16),
      ],
      // PHYSICAL
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      email: ["", Validators.required, , Validators.email],
      // LEGAL
      name: ["", Validators.required],
      vatNumber: [
        "",
        Validators.required,
        ,
        Validators.minLength(11),
        Validators.maxLength(11),
      ],
      taxType: ["cf",Validators.required]
    });
  }

  ngOnInit() {
    this.personType = this.dialogConfig.data.personTypes;
    this.formEdit = this.dialogConfig.data.formSettings.formEdit;
    if (this.formEdit) this.setFormToEdit();
  }

  onEditComplete() {
    this.modalRef.close({
      data: { ...this.newPersonForm.value, id: this.formData.id },
      edit: true,
    });
  }

  onAddPerson() {
    let newPerson: FormGroup = this.newPersonForm;
    let type = newPerson.value.taxType;
    newPerson.removeControl("taxType");
    if(newPerson.value.type == "LEGAL_ENTITY"){
      if(type == "pi") newPerson.value.taxNumber = newPerson.value.vatNumber;
    }
    this.modalRef.close(newPerson.value);
  }

  formReset() {
    this.newPersonForm.reset();
    this.newPersonForm.value.taxType = "cf";
    if (this.formEdit) this.setFormToEdit();
    this.updateValidators();
  }

  setFormToEdit() {
    this.formData = this.dialogConfig.data.formSettings.formData;
    const formFormat = {
      type: this.formData.type,
      taxNumber: this.formData.taxNumber,

      firstName: this.formData.firstName ? this.formData.firstName : "",
      lastName: this.formData.lastName ? this.formData.lastName : "",
      email: this.formData.email ? this.formData.email : "",
      taxType: this.formData.vatNumber ? "pi" : "cf",
      name: this.formData.name ? this.formData.name : "",
      vatNumber: this.formData.vatNumber ? this.formData.vatNumber : "",
    };
    this.newPersonForm.setValue(formFormat);
    this.updateValidators();
  }

  updateValidators() {
    if (this.newPersonForm.value.type == "LEGAL_ENTITY") {
      this.newPersonForm.controls["taxType"].setValidators([Validators.required]);
      if(this.newPersonForm.value.taxType == "pi"){
        this.newPersonForm.controls["vatNumber"].setValidators([
          Validators.required,
          ,
          Validators.minLength(11),
          Validators.maxLength(11),
        ]);
        this.newPersonForm.value.taxNumber = "";
        this.newPersonForm.controls["taxNumber"].clearValidators();
        this.newPersonForm.controls["taxNumber"].updateValueAndValidity();
      } else if(this.newPersonForm.value.taxType == "cf"){
        this.newPersonForm.controls["taxNumber"].setValidators([
          Validators.required,
          ,
          Validators.minLength(16),
          Validators.maxLength(16),
        ]);
        this.newPersonForm.value.vatNumber = "";
        this.newPersonForm.controls["vatNumber"].clearValidators();
        this.newPersonForm.controls["vatNumber"].updateValueAndValidity();
      }

      this.newPersonForm.controls["name"].setValidators([Validators.required]);


      this.newPersonForm.controls["firstName"].clearValidators();
      this.newPersonForm.controls["firstName"].updateValueAndValidity();
      this.newPersonForm.controls["lastName"].clearValidators();
      this.newPersonForm.controls["lastName"].updateValueAndValidity();
      this.newPersonForm.controls["email"].clearValidators();
      this.newPersonForm.controls["email"].updateValueAndValidity();
    }
    if (this.newPersonForm.value.type == "PHYSICAL_ENTITY") {
      this.newPersonForm.controls["taxNumber"].setValidators([
        Validators.required,
        ,
        Validators.minLength(16),
        Validators.maxLength(16),
      ]);
      this.newPersonForm.controls["firstName"].setValidators([
        Validators.required,
      ]);
      this.newPersonForm.controls["firstName"].updateValueAndValidity();
      this.newPersonForm.controls["lastName"].setValidators([
        Validators.required,
      ]);
      this.newPersonForm.controls["lastName"].updateValueAndValidity();
      this.newPersonForm.controls["email"].setValidators([
        Validators.required,
        ,
        Validators.email,
      ]);
      this.newPersonForm.controls["email"].updateValueAndValidity();

      this.newPersonForm.controls["name"].clearValidators();
      this.newPersonForm.controls["name"].updateValueAndValidity();
      this.newPersonForm.controls["vatNumber"].clearValidators();
      this.newPersonForm.controls["vatNumber"].updateValueAndValidity();
      this.newPersonForm.controls["taxType"].clearValidators();
      this.newPersonForm.controls["taxType"].updateValueAndValidity();

    }
  }
}
